import { computed, ref } from 'vue'
import { apiFetch } from '~/composables/useFetcher'

interface OperationNationaleInformations {
  missions_count: number
  participations_count: number
}

export type OperationNationaleKey = 'tournee-ete' | 'printemps-pour-la-planete'

export function useOperationNationale(operationKey: OperationNationaleKey) {
  const isFetchingInformations = ref(false)

  const informations = ref<OperationNationaleInformations>({
    missions_count: 0,
    participations_count: 0,
  })

  async function fetchInformations() {
    await apiFetch(`/operations-nationales/${operationKey}`)
      .then((res) => {
        informations.value = res as OperationNationaleInformations
      })
      .catch((error) => {
        console.error('error', error)
      })
      .finally(() => {
        isFetchingInformations.value = false
      })
  }

  const operationEndDate = computed(() => {
    switch (operationKey) {
      case 'tournee-ete':
        return new Date('2025-07-01')
      case 'printemps-pour-la-planete':
        return new Date('2025-06-01')
      default:
        return new Date()
    }
  })

  const daysLeft = computed(() => {
    const endDate = operationEndDate.value
    const today = new Date()
    const timeDiff = endDate.getTime() - today.getTime()
    const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24))
    return daysLeft > 0 ? daysLeft : 0
  })

  return {
    daysLeft,
    informations,
    isFetchingInformations,
    fetchInformations,
  }
}
